import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import PopularArticles from './components/PopularArticles';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <LatestArticles />
        <PopularArticles />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}